import { render, staticRenderFns } from "./CredentialSave.vue?vue&type=template&id=560f286e&scoped=true&"
import script from "./CredentialSave.vue?vue&type=script&lang=js&"
export * from "./CredentialSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f286e",
  null
  
)

export default component.exports